import React from "react";

export interface IAlunoEnrollContext {
    showExcluded: boolean;
}

export const AlunoEnrollContext = React.createContext<IAlunoEnrollContext>({
    showExcluded: false,
});
